import Bank from "./images/bank.svg";
import Doc from "./images/doc.svg";
import Coin from "./images/coin.svg";
import Phone from "./images/phone.svg";

export const HOLDBACK_TYPE = {
    LOAN_NOC: "NOC HOLD",
    PARTY_PESHI: "Party Peshi HOLD"
};

export const HOLDBACK_DETAILS = {
    [HOLDBACK_TYPE.LOAN_NOC]: {
        title: "Loan NOC on-hold amount",
        stepTitle: "Steps to submit Loan NOC, Form 35",
        steps: [
            {
                heading: "Visit your Bank",
                desc: "To get a physical copy of the Loan NOC and 2 copies of Form 35.",
                img: Bank
            },
            {
                heading: "Submit the physical documents",
                desc: "CARS24 team will collect these from you, or raise a request at care@cars24.com",
                img: Doc
            },
            {
                heading: "Receive remaining amount in 2-3 days",
                desc: "Once we validate the submitted documents with your bank.",
                img: Coin
            }
        ],
        footer: "",
        bottomText: "submit physical copies of NOC and Form 35 "
    },
    [HOLDBACK_TYPE.PARTY_PESHI]: {
        title: "Party Peshi on-hold amount",
        stepTitle: "Steps to complete Party Peshi",
        steps: [
            {
                heading: "CARS24 team will contact you",
                desc: "To set a date and time for RTO Party Peshi.",
                img: Phone
            },
            {
                heading: "Visit RTO",
                desc: "On the set date and time to complete the RC transfer process.",
                img: Bank
            },
            {
                heading: "Receive remaining in 2-3 days",
                desc: "Once our team verifies your visit to the RTO.",
                img: Coin
            }
        ],
        footer: "We will share your contact information with our dealers privately to ensure all the formalities are handled efficiently and safely.",
        bottomText: "complete your Party Peshi"
    }
};
